// src/pages/Login.jsx
import React, { useState } from "react";
import { auth } from "../services/api";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await auth.login(correo, password);

      if (!data?.success) throw new Error(data?.message || "Error");

      // ✅ Guarda la información del usuario
      localStorage.setItem("token", data.token);
      localStorage.setItem("rol", data.rol || "");
      if (data.empleado_id) {
        localStorage.setItem("empleado_id", data.empleado_id);
      }

      // ✅ Redirige según el rol
      const r = (data.rol || "").toLowerCase();
      navigate(
        r === "administrador"
          ? "/dashboard/administrador"
          : r === "gerente"
          ? "/dashboard/gerente"
          : "/dashboard/empleado"
      );
    } catch (err) {
      console.error("❌ Error login:", err);
      alert("Credenciales incorrectas o error de conexión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      p: 2,
      background: "#f7f7fb"
    }}>
      <Paper sx={{ p: 4, width: "100%", maxWidth: 420 }}>
        <Typography variant="h5" textAlign="center" mb={2}>
          Inicia sesión
        </Typography>
        <form onSubmit={onSubmit}>
          <TextField
            label="Correo"
            type="email"
            fullWidth
            margin="normal"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

